export default __webpack_public_path__ + "static/media/mShorts_1_c2.4696315d.jpeg";